import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { displayVersion } from "../utils/version-logger";

function MainLayout() {
  useEffect(() => {
    displayVersion();
  }, []);

  //prevent clickjacking
  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location.href = window.self.location.href;
    }
  }, []);

  return (
    <main>
      <Header />
      <Outlet />
      <Footer />
    </main>
  );
}

export default MainLayout;
